var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFinalCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_final_check"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_24748",
    "data-name": "\\uC0AC\\uAC01\\uD615 24748",
    width: 24,
    height: 24,
    fill: "#f1f1f1",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(-105.998 -43.451)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD569\\uCE58\\uAE30_9",
    "data-name": "\\uD569\\uCE58\\uAE30 9",
    d: "M1.315,14A1.391,1.391,0,0,1,0,12.533L0,2.27A1.525,1.525,0,0,1,1.434.93H2.9A1.411,1.411,0,0,1,4.151,0C4.2,0,4.25,0,4.3,0H8.056A1.394,1.394,0,0,1,9.437.93h1.54A1.522,1.522,0,0,1,12.34,2.338V6.087a.515.515,0,0,1-1.03,0V2.363a.477.477,0,0,0-.412-.427l-1.451,0a1.419,1.419,0,0,1-1.255.929,1.6,1.6,0,0,1-.16,0H4.285c-.025,0-.052,0-.079,0A1.4,1.4,0,0,1,2.9,1.94H1.458a.48.48,0,0,0-.433.408L1.03,12.563a.38.38,0,0,0,.352.422H9.543a.505.505,0,1,1,0,1.011H1.458a.34.34,0,0,1-.051,0C1.38,14,1.347,14,1.315,14ZM3.95,1.137a.355.355,0,0,0-.093.268v.1a.37.37,0,0,0,.4.348h3.8c.283-.012.442-.188.429-.392v-.1a.366.366,0,0,0-.4-.348H4.2A.371.371,0,0,0,3.95,1.137Zm7.388,11.88-1.372-1.3a3.747,3.747,0,0,1-2.253.744h0A3.669,3.669,0,1,1,11.443,8.79,3.6,3.6,0,0,1,10.693,11l1.359,1.3a.5.5,0,0,1,.013.715.52.52,0,0,1-.37.154A.512.512,0,0,1,11.338,13.017ZM5.011,8.79a2.683,2.683,0,0,0,2.7,2.657h0a2.7,2.7,0,0,0,1.909-.777,2.622,2.622,0,0,0,.792-1.88,2.7,2.7,0,0,0-5.4,0Z",
    transform: "translate(111.998 48.451)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFinalCheck);
export default __webpack_public_path__ + "static/media/icon_final_check.d657a74ff086f446d0d61734d74eb4f9.svg";
export { ForwardRef as ReactComponent };